import { useDashboardStore } from './DashboardStore';
import { useUnifiedDashboardStore } from './UnifiedDashboardStore';

export const resetDashboardSession = (): void => {
  useUnifiedDashboardStore.getState().resetUnifiedDashboardStore();
  useDashboardStore.getState().resetDashboardStore();
};
